import { css, styled } from '../../hooks/theme';
import { Tokens } from '../../types';

interface CompositeCheckBoxProps {
  checked: boolean;
  disabled?: boolean;
}

export const Container = styled.div<CompositeCheckBoxProps>`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 16px;
  width: 256px;

  font-family: ${props => props.theme.font.family.sans};
  font-size: ${props => props.theme.font.size.base};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  border: 1px solid
    ${props =>
      props.checked ? props.theme.colors.brand.primary[100] : props.theme.colors.neutral.grey[40]};
  border-radius: 4px;

  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+/Edge */
  user-select: none; /* Standard */

  ${props =>
    props.disabled
      ? css`
          opacity: 0.5;
          cursor: not-allowed;
          button {
            cursor: not-allowed;
          }
        `
      : css`
          &:hover {
            background: ${props.theme.colors.neutral.grey[5]};
          }
        `}
`;

Container.defaultProps = {
  theme: Tokens.eixods,
};

export const TextContainer = styled.div`
  margin-right: 12px;

  h4,
  p {
    line-height: 150%;
    margin: 0;
  }

  h4 {
    font-size: ${props => props.theme.font.size.base}px;
    font-weight: ${props => props.theme.font.weights.regular};
    margin-bottom: 2px;
  }

  p {
    font-size: ${props => props.theme.font.size.base}px;
    color: ${props => props.theme.colors.neutral.grey[70]};
  }
`;

TextContainer.defaultProps = {
  theme: Tokens.eixods,
};

export const CheckBoxContainer = styled.button<CompositeCheckBoxProps>`
  width: 24px;
  height: 24px;

  background: ${props => (props.checked ? props.theme.colors.brand.primary[100] : 'none')};
  border: 1px solid
    ${props =>
      props.checked ? props.theme.colors.neutral.grey[40] : props.theme.colors.neutral.grey[40]};
  border-radius: 4px;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: background 0.1s;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    transform: scale(1.3);
    opacity: ${props => (props.checked ? 1 : 0)};
    transition: opacity 0.1s;
    -webkit-filter: brightness(99999%); /* Safari/Chrome */
    filter: brightness(99999%);
  }
`;

CheckBoxContainer.defaultProps = {
  theme: Tokens.eixods,
};
